// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wrapper":"change-award-mode__wrapper--2oeCE","module_wrapper":"change-award-mode__module_wrapper--3dMc9","moduleWrapper":"change-award-mode__module_wrapper--3dMc9"};